
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#000","stroke-width":".917","d":"M20.25 1H3.75A2.75 2.75 0 001 3.75v12.37a2.76 2.76 0 002.75 2.76h4.13v3.6a.507.507 0 00.51.52c.111 0 .22-.036.31-.1l5.36-4h6.19A2.759 2.759 0 0023 16.12V3.75A2.75 2.75 0 0020.25 1z"}}),_c('path',{attrs:{"fill":"#FFD250","d":"M9.706 14.034l2.196-1.21 2.197 1.21c.39.216.858-.131.781-.59l-.422-2.56 1.779-1.81c.319-.323.144-.89-.297-.96l-2.457-.376-1.1-2.325a.53.53 0 00-.966 0l-1.1 2.325-2.457.375c-.44.066-.616.633-.297.961l1.783 1.81-.422 2.56c-.076.463.39.806.782.59z"}})])])
          )
        }
      }
    